import formulario from "../formulario";
var contacto = function (dataLayer) {
    formulario('.contacto form', dataLayer);
};
export default contacto;
